import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useGetTeacherEvaluationsQuery, useGetTeacherEvaluationsReportQuery } from "../../hooks/useGetTeacherEvaluationsQuery";
import { Box, Button, Callout, Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import TeacherEvaluationSummary from "./ReportsCards/TeacherEvaluationSummary";
import ClassificationDistributionChart from "./ReportsCards/ClassificationDistributionChart ";
import TrendOverYearsChart from "./ReportsCards/TrendOverYearsChart";
import CriteriaScoresTable from "./ReportsCards/CriteriaScoresTable";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { useAppDispatch } from "../../hooks/hooks";
import { resetTeacherData, resetUpdateTeachertData } from "../../redux/slices/school/teacher";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";

export const TeacherEvaluations = () => {
  const teacherData = useSelector((state: RootState) => state.teacher.teacher);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    data: teacherEvaluationsReport,
    isLoading: isLoadingTeacherEvaluationsReport,
    isError: isErrorTeacherEvaluationsReport,
    refetch: refreshTeacherEvaluationsReport
  } = useGetTeacherEvaluationsReportQuery({
    PageNumber: 1,
    PageSize: 400,
    IdTeacher: teacherData?.id
  }, {
    enabled: !!teacherData?.id
  });

  const handleBack = () => {
    dispatch(resetTeacherData());
    dispatch(resetUpdateTeachertData());
    navigate(routes.teachers);
  }

  if (isLoadingTeacherEvaluationsReport)
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner loading />
      </Flex>
    );

  if (isErrorTeacherEvaluationsReport)
    return (
      <Callout.Root color="red">
        <Text>Erro ao carregar o relatório. Por favor, tente novamente.</Text>
      </Callout.Root>
    );

  if (!teacherEvaluationsReport)
    return (
      <Callout.Root color="blue">
        <Text>Nenhum dado disponível para o docente selecionado.</Text>
      </Callout.Root>
    );
    const { summary, classificationDistributions, trendOverYears, criteriaScores } = teacherEvaluationsReport;


    return (
  <Flex direction='column' gap='2'>

    
      <Box>
        <Heading as="h1"  weight="bold" mb="4">
          Relatório de Avaliações do docente
        </Heading>
  
        <Box mb="6">
          <TeacherEvaluationSummary summary={summary} />
        </Box>
  
        <Flex gap="6" wrap="wrap">
          <Box width="100%" maxWidth="600px">
            {classificationDistributions?.length > 0 ? (
              <ClassificationDistributionChart data={classificationDistributions} />
            ) : (
              <Callout.Root color="blue">
                <Text>Nenhuma distribuição de classificações disponível.</Text>
              </Callout.Root>
            )}
          </Box>
  
          <Box width="100%" maxWidth="600px">
            {trendOverYears?.length > 0 ? (
              <TrendOverYearsChart data={trendOverYears} />
            ) : (
              <Callout.Root color="blue">
                <Text>Nenhuma tendência ao longo dos anos disponível.</Text>
              </Callout.Root>
            )}
          </Box>
        </Flex>
  
        <Box mt="6">
          {criteriaScores?.length > 0 ? (
            <CriteriaScoresTable data={criteriaScores} />
          ) : (
            <Callout.Root color="blue">
              <Text>Nenhuma pontuação por critérios disponível.</Text>
            </Callout.Root>
          )}
        </Box>
      </Box>


     <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                    <Button color='red'
                      onClick={handleBack}
                    >
                      <ChevronLeftIcon /> Voltar
                    </Button>
                    
                  </Flex>
  </Flex>
      

    );
};
